import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_LINK_API,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=utf-8",
  },
});

api.interceptors.request.use(async (config) => {
  const session = await JSON.parse(sessionStorage.getItem("@dataUser"));
  if (session?.token) config.headers.Authorization = `Bearer ${session?.token}`;

  return config;
});

export default api;
